import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useState } from 'react';
import { useInterval } from 'react-use';
dayjs.extend(duration);
const INITIAL_VALUE = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
};
export const getFormatCountdown = dateForCd => {
  const convertedDate = dayjs.isDayjs(dateForCd) ? dateForCd : dayjs(dateForCd);
  const diff = convertedDate.diff(dayjs());
  const deltaMs = Math.max(0, diff);
  const duration = dayjs.duration(deltaMs);
  return [deltaMs, {
    days: Math.floor(duration.asDays()),
    hours: duration.get('hours'),
    minutes: duration.get('minutes'),
    seconds: duration.get('seconds')
  }];
};

const useDateCountdown = (date, onFinishCallback) => {
  const [countdownUnits, setCountdownUnits] = useState(INITIAL_VALUE);
  useInterval(() => {
    const [delta, cdUnits] = getFormatCountdown(date);
    setCountdownUnits(delta <= 0 ? INITIAL_VALUE : cdUnits);

    if (delta <= 0) {
      onFinishCallback === null || onFinishCallback === void 0 ? void 0 : onFinishCallback();
    }
  }, 1000);
  return countdownUnits;
};

export default useDateCountdown;